import request from "../utils/request";

export function getStatisticsPage(data,pageNum,pageSize) {
    return request({
        url: '/statistics/findPage',
        method: 'post',
        params: { pageNum: pageNum,pageSize:pageSize },
        data
    })
}

export function getAll (data) {
    return request({
        url: 'statistics/all?month=' + data,
        method: 'get'
    })
}


export function getYearDateToInvest () {
    return request({
        url: 'statistics/yearDateToInvest',
        method: 'get'
    })
}
